// FieldIQ — Header profile avatar button

import { useState, useEffect } from "react";
import { User } from "lucide-react";

const _AVATAR_FILLS = ["#3f4759", "#475569", "#52525b", "#525252", "#44403c"];

export const ProfileAvatar = ({ user, photoUrl, onClick }) => {
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setImgError(false);
  }, [photoUrl]);

  const initials = (() => {
    const f = user?.first_name?.[0] || "";
    const l = user?.last_name?.[0] || "";
    if (f || l) return (f + l).toUpperCase();
    return (user?.name || user?.email || "").slice(0, 2).toUpperCase();
  })();

  const fill = (() => {
    const seed = user?.id || user?.email || "x";
    let h = 0;
    for (let i = 0; i < seed.length; i++)
      h = (h * 31 + seed.charCodeAt(i)) & 0xffff;
    return _AVATAR_FILLS[h % _AVATAR_FILLS.length];
  })();

  const hasPhoto = !!photoUrl && !imgError;

  return (
    <button
      onClick={onClick}
      className="flex items-center justify-center flex-shrink-0"
      style={{ width: 44, height: 44 }}
      aria-label="Profile"
    >
      <div className="w-8 h-8 rounded-full overflow-hidden flex items-center justify-center bg-slate-700 flex-shrink-0">
        {hasPhoto ? (
          <img
            src={photoUrl}
            alt=""
            className="w-full h-full object-cover"
            onError={() => setImgError(true)}
          />
        ) : initials ? (
          <div
            className="w-full h-full flex items-center justify-center"
            style={{ backgroundColor: fill }}
          >
            <span className="text-xs font-semibold text-slate-200 leading-none select-none">
              {initials}
            </span>
          </div>
        ) : (
          <User size={15} className="text-slate-400" strokeWidth={1.5} />
        )}
      </div>
    </button>
  );
};
